/** This should reflect FormSteps enum */
export const StepsLabel = ['Toll account details', 'Sole trader details', 'Supporting details', 'Review'];
